"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5.5 4A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20H13a.5.5 0 0 0 0-1H5.5a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5H13a.5.5 0 0 0 0-1z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M17.384 8.68a.5.5 0 1 0-.768.64l1.817 2.18H11a.5.5 0 0 0 0 1h7.433l-1.817 2.18a.5.5 0 0 0 .768.64l2.5-3a.5.5 0 0 0 0-.64z"
  })]
}), 'Logout');
